/** Shortest playable region, in seconds (same as the desktop minimum). */
export const MIN_LEN_S = 3;

/** Longest region a player may pick on the web (same as the desktop maximum). */
export const MAX_LEN_WEB_S = 30;

/** Largest accepted song upload: 20 MiB. */
export const MAX_SONG_BYTES = 20 * 1024 * 1024;

/** Largest accepted player or operator photo: 5 MiB. */
export const MAX_PHOTO_BYTES = 5 * 1024 * 1024;

/** Longest song duration the upload accepts, in milliseconds (24 h). */
export const MAX_SONG_DURATION_MS = 24 * 60 * 60 * 1000;

/** Most slots (cells) one configuration may hold; matches the desktop bundle limit. */
export const MAX_SLOTS = 500;

/** Audio formats the web platform accepts for songs. WAV and FLAC are refused (no browser conversion). */
export const SONG_EXTENSIONS = ["mp3", "m4a", "aac"] as const;

/** Image formats accepted for player photos. */
export const PHOTO_EXTENSIONS = ["png", "jpg", "jpeg"] as const;

/** `.goalhorns` bundle format version written by the web export (desktop-compatible). */
export const BUNDLE_FORMAT_VERSION = 2;

export type SongExtension = (typeof SONG_EXTENSIONS)[number];
export type PhotoExtension = (typeof PHOTO_EXTENSIONS)[number];

/** Version of the sync API payloads. Bumped only on a breaking change to the wire format. */
export const SYNC_VERSION = 1;

/** Prefix on every configuration API key, so leaked keys are easy to spot in logs and scanners. */
export const API_KEY_PREFIX = "ghk_";

/** Random bytes in an API key before base64url encoding (256 bits). */
export const API_KEY_BYTES = 32;

/** Longest label an operator can give a key. */
export const API_KEY_LABEL_MAX = 60;

/** Desktop device keys start with this prefix, distinct from the `ghk_` configuration API keys. */
export const DEVICE_KEY_PREFIX = "ghd_";

/** Link codes skip 0, O, 1 and I so they are hard to misread when typed. */
export const LINK_CODE_ALPHABET = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";

export const LINK_CODE_LENGTH = 7;

export const LINK_CODE_TTL_MS = 10 * 60 * 1000;

export const DEVICE_NAME_MAX = 60;

/** Most sha256 values one device missing-media check may name. */
export const DEVICE_MISSING_MEDIA_MAX = 500;
